import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocaleService } from '../../common/locale/locale.service';
import { AssociateSearchModalComponent } from '../associate-search-modal/associate-search-modal.component';
import {UserService} from "../../../modules/common/user.service";

@Component({
    selector: 'u-dc-associate-search-trigger',
    template: '',
    standalone: true,
})
export class AssociateSearchTriggerComponent implements AfterViewInit, OnDestroy {
    private localeSub: Subscription;

    constructor(
        private readonly modalService: NgbModal,
        private readonly router: Router,
        private readonly localeService: LocaleService,
        private readonly userService: UserService,
    ) {}

    ngAfterViewInit(): void {

        const modalRef = this.modalService.open(AssociateSearchModalComponent, {
            windowClass: 'dotcom-side-modal',
        });
    }

    ngOnDestroy(): void {
        this.localeSub?.unsubscribe();
    }

}
